import styled from 'styled-components';

import {colors} from '@app/styles/theme';

export const RangeInputContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: stretch;
`;

export const RangeSeparator = styled.div`
    width: 30px;
    &::before {
        content: '—';
        display: flex;
        justify-content: center;
        align-items: center;
        color: ${colors.textSecondary};
    }
`;
